import type { UpdateUserResponse } from '@vy/api-definition';
import type { Role } from '@vy/types';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';

type mutationInputType = {
  role: Role;
  userId: string;
};

export function useUpdateUserRole(
  options?: UseMutationOptions<UpdateUserResponse, unknown, mutationInputType>,
) {
  const queryClient = useQueryClient();

  const mutationFn = (variables: mutationInputType) => {
    const api = getPrivateApi();

    return api.updateUser({
      userId: variables.userId,
      updateUserRequest: {
        role: variables.role,
      },
    });
  };

  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(queryKeys.users());
    },
    ...options,
  });
}
